import { DELETE_DRAWER_START } from "../../types";

export const delete_drawer = (payload) => ({
    type: DELETE_DRAWER_START,
    payload,
});
